/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { TextProcessorPatternDto } from '../models';
// @ts-ignore
import type { TextProcessorPatternPatchDto } from '../models';
/**
 * TextProcessorApi - axios parameter creator
 * @export
 */
export const TextProcessorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTextProcessorConfiguration: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTextProcessorConfiguration', 'id', id)
            const localVarPath = `/bo/v1/text-processor/patterns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTextProcessorConfigurations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bo/v1/text-processor/patterns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {TextProcessorPatternPatchDto} textProcessorPatternPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTextProcessorConfiguration: async (id: string, textProcessorPatternPatchDto: TextProcessorPatternPatchDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTextProcessorConfiguration', 'id', id)
            // verify required parameter 'textProcessorPatternPatchDto' is not null or undefined
            assertParamExists('updateTextProcessorConfiguration', 'textProcessorPatternPatchDto', textProcessorPatternPatchDto)
            const localVarPath = `/bo/v1/text-processor/patterns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(textProcessorPatternPatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TextProcessorApi - functional programming interface
 * @export
 */
export const TextProcessorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TextProcessorApiAxiosParamCreator(configuration)
    return {
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTextProcessorConfiguration(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTextProcessorConfiguration(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TextProcessorApi.deleteTextProcessorConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTextProcessorConfigurations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TextProcessorPatternDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTextProcessorConfigurations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TextProcessorApi.getAllTextProcessorConfigurations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {TextProcessorPatternPatchDto} textProcessorPatternPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTextProcessorConfiguration(id: string, textProcessorPatternPatchDto: TextProcessorPatternPatchDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextProcessorPatternDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTextProcessorConfiguration(id, textProcessorPatternPatchDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TextProcessorApi.updateTextProcessorConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TextProcessorApi - factory interface
 * @export
 */
export const TextProcessorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TextProcessorApiFp(configuration)
    return {
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTextProcessorConfiguration(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTextProcessorConfiguration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTextProcessorConfigurations(options?: RawAxiosRequestConfig): AxiosPromise<Array<TextProcessorPatternDto>> {
            return localVarFp.getAllTextProcessorConfigurations(options).then((request) => request(axios, basePath));
        },
        /**
         * hasBackOfficeFullRole()
         * @param {string} id 
         * @param {TextProcessorPatternPatchDto} textProcessorPatternPatchDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTextProcessorConfiguration(id: string, textProcessorPatternPatchDto: TextProcessorPatternPatchDto, options?: RawAxiosRequestConfig): AxiosPromise<TextProcessorPatternDto> {
            return localVarFp.updateTextProcessorConfiguration(id, textProcessorPatternPatchDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TextProcessorApi - object-oriented interface
 * @export
 * @class TextProcessorApi
 * @extends {BaseAPI}
 */
export class TextProcessorApi extends BaseAPI {
    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextProcessorApi
     */
    public deleteTextProcessorConfiguration(id: string, options?: RawAxiosRequestConfig) {
        return TextProcessorApiFp(this.configuration).deleteTextProcessorConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextProcessorApi
     */
    public getAllTextProcessorConfigurations(options?: RawAxiosRequestConfig) {
        return TextProcessorApiFp(this.configuration).getAllTextProcessorConfigurations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * hasBackOfficeFullRole()
     * @param {string} id 
     * @param {TextProcessorPatternPatchDto} textProcessorPatternPatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextProcessorApi
     */
    public updateTextProcessorConfiguration(id: string, textProcessorPatternPatchDto: TextProcessorPatternPatchDto, options?: RawAxiosRequestConfig) {
        return TextProcessorApiFp(this.configuration).updateTextProcessorConfiguration(id, textProcessorPatternPatchDto, options).then((request) => request(this.axios, this.basePath));
    }
}

